import { Button, Col, Container, Row } from '@microfrontends/react-components'
import Link from 'next/link'
import { useContext, useEffect, useState } from 'react'
import Banner from '../../../components/NumerologyV2/Banner'
import { rulingNumbers } from '../../../components/NumerologyV2/const'
import { Paragraph } from '../../../components/NumerologyV2/index.css'
import { Number } from '../../../components/NumerologyV2/Number'
import Title from '../../../components/NumerologyV2/Title'
import AppContext from '../../../context/AppContext'
import NumerologyApi from '../../../services/numerology'
import {
	TNumerologyDetail,
	TUserInfoInNumerlogy
} from '../../../services/numerology/@type'
import { EDevice } from '../../MainLayout'
import { Box, CustomLink, RulingNumberContainer } from '../Numerology.css'
import MyRulingNumber from './MyRulingNumber'

interface IProps {
	handleOpen?: () => void
	rulingNumberDetail: (TNumerologyDetail & TUserInfoInNumerlogy) | null
}

export default function RulingNumber({
	handleOpen,
	rulingNumberDetail
}: IProps) {
	const { breakpoint, t, user } = useContext(AppContext)

	return (
		<RulingNumberContainer>
			<Container>
				<Row justify='center' align='middle'>
					{rulingNumberDetail?.userInfo?.rulingNumber &&
					rulingNumberDetail?.userInfo?.rulingNumber !== 0 ? (
						<Col>
							<MyRulingNumber
								rulingNumber={
									rulingNumberDetail?.userInfo
										?.rulingNumber ?? 0
								}
							/>
						</Col>
					) : null}
					<Col>
						<Box className='center'>
							<Title
								marker='triangle'
								title='Ý nghĩa các con số chủ đạo'
								titleStyle={{ color: '#fff' }}
							/>
							<Paragraph color='#fff' textAlign='center'>
								Cùng VietnamWorks tìm hiểu thêm về ý nghĩa những
								con số trong con số chủ đạo của bản thân để đối
								chiếu lại chính mình trên hành trình tìm kiếm
								nghề nghiệp phù hợp
							</Paragraph>
						</Box>
					</Col>

					<Box className='row' style={{ gap: 20 }}>
						{rulingNumbers.map((elm, index) => {
							return (
								<Link
									key={index}
									href={`${t('/ruling-number')}/${
										elm.number
									}`}
									passHref
								>
									<CustomLink>
										<Number
											svg={elm.svg}
											number={elm.number}
										/>
									</CustomLink>
								</Link>
							)
						})}
					</Box>
					<Col>
						{breakpoint !== EDevice.MOBILE ? (
							<Box className='center'>
								<Button
									type='primary'
									className='search_button'
									onClick={handleOpen}
									style={{ marginBottom: -70 }}
								>
									{t('Tra cứu nhân số học')}
								</Button>
							</Box>
						) : null}
					</Col>
				</Row>
			</Container>
		</RulingNumberContainer>
	)
}
